import React, { useState, useEffect } from "react";
import { Link, graphql } from "gatsby";

import Layout from "../components/layout";
import Image from "../components/image";
import SEO from "../components/seo";
import Header from "../components/header/header";
import "../styles/default-blog.scss";
import Img from "gatsby-image";
import SearchBlog from "../components/SearchBlog";
import TagPill from "../components/TagPill";
import TagCard from "../components/TagCard";

function IndexPage(props) {
  const initialPosts = props.data.allMarkdownRemark.edges;
  const [posts, setPosts] = useState(initialPosts);
  const [term, setTerm] = useState("");
  const [tags, setTags] = useState([]);

  useEffect(() => {
    getAllTags();
  }, []);

  function getAllTags() {
    let allTags = [];

    posts.forEach(post => {
      const postTags = post.node.frontmatter.tags.split(",");
      allTags = [...allTags, ...postTags];
    });

    const filteredTags = allTags.filter(
      (tag, index) => allTags.indexOf(tag) === index
    );

    setTags(filteredTags);
  }

  function handleSearch(e) {
    // Set search term
    const searchTerm = e.target.value.toLowerCase();
    setTerm(searchTerm);

    // If search term is empty return all posts
    if (searchTerm.length === 0) {
      return setPosts(initialPosts);
    }

    // filter posts based on search term
    const updatedPosts = initialPosts.filter(post => {
      const postTitleLowerCase = post.node.frontmatter.title.toLowerCase();
      return postTitleLowerCase.includes(searchTerm);
    });

    // Set posts to filtered posts based on search term
    setPosts(updatedPosts);
  }

  function searchByTag(tag) {
    // Reset search box
    setTerm("");

    const filteredPosts = initialPosts.filter(post => {
      const postTags = post.node.frontmatter.tags.split(",");

      if (postTags.includes(tag)) {
        return post;
      }
    });

    setPosts(filteredPosts);
  }

  return (
    <Layout>
      <SEO
        title="Andy Coupe - JavaScript Developer"
        keywords={[`gatsby`, `andy`, `coupe`, `blog`, `javascript`]}
      />

      <SearchBlog value={term} onChange={handleSearch} />
      <div className="tags-wrapper">
        {tags.map((tag, index) => (
          <TagCard
            key={index}
            tag={tag}
            value={tag}
            onClick={e => searchByTag(e.target.value)}
          />
        ))}
      </div>
      <div className="post-list">
        {posts.length
          ? posts.map(({ node }, i) => (
              <Link key={i} to={node.fields.slug} className="link">
                <div className="post-card">
                  <div className="post-card__title-wrapper">
                    <div className="inner">
                      <h2>{node.frontmatter.title}</h2>
                      <p className="excerpt">
                        {node.excerpt.substring(0, 70)}...
                      </p>
                    </div>
                    <Img
                      backgroundColor={true}
                      fadeIn={true}
                      fluid={
                        node.frontmatter.featuredImage.childImageSharp.fluid
                      }
                      // fixed={
                      //   node.frontmatter.featuredImage.childImageSharp.fixed
                      // }
                    />
                  </div>
                  <div className="post-info-wrapper">
                    <span className="blog-list__date">
                      {node.frontmatter.date}
                    </span>
                    <span className="blog-list__read-time">
                      {node.frontmatter.readTime}
                    </span>
                  </div>
                  <div className="pill-wrapper">
                    {node.frontmatter.tags.split(",").map((tag, index) => (
                      <TagPill key={index} tag={tag} />
                    ))}
                  </div>
                </div>
              </Link>
            ))
          : "No posts found!"}
      </div>
    </Layout>
  );
}

export const listQuery = graphql`
  query ListQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          fields {
            slug
          }
          excerpt(pruneLength: 100)
          frontmatter {
            date(formatString: "MMMM Do YYYY")
            title
            readTime
            tags
            featuredImage {
              childImageSharp {
                resize(width: 1000, height: 420) {
                  src
                }
                fluid(maxWidth: 786) {
                  ...GatsbyImageSharpFluid
                }
                fixed(width: 200, height: 200) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
